'use client';
var classes = {"root":"m_6d731127"};

export { classes as default };
//# sourceMappingURL=Stack.module.css.mjs.map
